import { InjectionKey } from 'vue';

export const textClipboardKey: InjectionKey<TextClipboard> = Symbol();

export interface TextClipboard {
  copy(text: string): Promise<void>;
}
